let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fTI2h")).then(() => parcelRequire('3xPiH'));